import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomerFiberConnectionsSettings } from '../../state/network-parameters.model.generated';

@Component({
  selector: 'app-fiber-connection',
  templateUrl: './fiber-connection.component.html',
  styleUrls: ['./fiber-connection.component.scss']
})
export class FiberConnectionComponent implements OnInit {

  @Input()
  form: FormGroup;

  @Input()
  settings: CustomerFiberConnectionsSettings;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void { }

}
